export default {
  SPIN: '轉',
  'You are not eligible for free spins':
    '只有具備 CSGO 遊戲的 steam 帳號而且沒有防作弊記錄者，才有資格取得免費遊戲幣。請重新登入網站更新。',
  'It must be 24 hours since last roll': '自上次滾動後必須經過 24 小時。',
};
